import styled from 'styled-components'

const ComponentStyled = styled.div`
  .wish-preview-box {
    max-width: 600px;
    margin: 0 auto;
    position: relative;

    .wish-preview-content {
      background-color: ${({ theme }) => theme.colors.secondaries.opacity30};
      padding: 24px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .wish-wrapper {
        max-width: 380px;
        margin: 0 auto;
      }

      .next-btn-wrapper {
        margin-top: 25px;
        text-align: center;
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    .wish-preview-box {
      .wish-preview-content {
        .wish-wrapper {
          max-width: 100%;
        }
      }
    }
  }
`

export default ComponentStyled
